import { createRouter, createWebHistory } from 'vue-router'

import { checkHestiaCustomersFeatureFlag } from '@/features/app-store/router/guards/checkHestiaCustomersFeatureFlag'
import { checkHestiaLoyaltyFeatureFlag } from '@/features/app-store/router/guards/checkHestiaLoyaltyFeatureFlag'
import { checkHestiaMarketingFeatureFlag } from '@/features/app-store/router/guards/checkHestiaMarketingFeatureFlag'
import { checkHestiaOrdersFeatureFlag } from '@/features/app-store/router/guards/checkHestiaOrdersFeatureFlag'
import { checkHestiaPaymentsFeatureFlag } from '@/features/app-store/router/guards/checkHestiaPaymentsFeatureFlag'
import { checkHestiaStaffFeatureFlag } from '@/features/app-store/router/guards/checkHestiaStaffFeatureFlag'
import { checkCredentialSetupFeatureFlag } from '@/features/auth/router/guards/checkCredentialSetupFeatureFlag'
import { checkGiftCardImportFeatureFlag } from '@/features/gift-cards/router/guards/checkGiftCardImportFeatureFlag'
import { checkMarketingOverviewV2FeatureFlag } from '@/features/marketing/router/guards/checkMarketingOverviewV2FeatureFlag'
import { checkMenuScorecardFeatureFlag } from '@/features/menu/router/guards/checkMenuScorecardFeatureFlag'
import { checkMenuFixerAgentFeatureFlag } from '@/features/menu-fixer-agent/router/guards/checkMenuFixerAgentFeatureFlag'
import { checkGuestPhotoReviewerFeatureFlag } from '@/features/photo-moderation/router/guards/checkGuestPhotoReviewerFeatureFlag'
import { checkCanadianPrintShopBlocked } from '@/features/print-shop-embed/router/guards/checkCanadianPrintShopBlocked'
import { checkSalesFeatureFlag } from '@/features/sales/router/guards/checkSalesFeatureFlag'
import { checkLegacyGbpFlowRedirect } from '@/features/setup/router/guards/checkLegacyGbpFlowRedirect'
import { checkLegacyGuestImportRedirect } from '@/features/setup/router/guards/checkLegacyGuestImportRedirect'
import { checkPhoneOrderingFeatureFlag } from '@/features/tools/router/guards/checkPhoneOrderingFeatureFlag'
import { checkWebsiteDesignRoute } from '@/features/website-builder/router/guards/checkWebsiteDesignRoute'

import { checkAuthenticated } from './guards/checkAuthenticated'
import { checkBrandAccess } from './guards/checkBrandAccess'
import { checkPermissions } from './guards/checkPermissions'
import { ensureLocationIdParam } from './guards/ensureLocationIdParam'
import { handleAfterEach } from './handleAfterEach'
import routes from './routes'

export const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: 'is-active',
  routes,
})

const guards = [
  checkCredentialSetupFeatureFlag,
  checkAuthenticated,
  checkPermissions,
  checkBrandAccess,
  checkWebsiteDesignRoute,
  checkGiftCardImportFeatureFlag,
  checkGuestPhotoReviewerFeatureFlag,
  checkHestiaCustomersFeatureFlag,
  checkHestiaLoyaltyFeatureFlag,
  checkHestiaMarketingFeatureFlag,
  checkHestiaOrdersFeatureFlag,
  checkHestiaPaymentsFeatureFlag,
  checkHestiaStaffFeatureFlag,
  checkCanadianPrintShopBlocked,
  checkLegacyGbpFlowRedirect,
  checkLegacyGuestImportRedirect,
  checkMarketingOverviewV2FeatureFlag,
  checkMenuFixerAgentFeatureFlag,
  checkMenuScorecardFeatureFlag,
  checkPhoneOrderingFeatureFlag,
  checkSalesFeatureFlag,
  ensureLocationIdParam,
]

router.beforeEach(async (to, from) => {
  for (const guard of guards) {
    const redirect = await guard(to, from)
    if (redirect) return redirect
  }
})

router.afterEach(handleAfterEach)
